// extracted by mini-css-extract-plugin
export default {"inline":"SubmitSystemTaskButton-styles-module--inline--aew7s"};